import useJwt from '@/auth/jwt/useJwt';

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName);
};

export const getUserData = () => JSON.parse(localStorage.getItem('userData'));

// Pages a user can be dropped on when the one they asked for is not theirs,
// keyed by the permission that opens each. userPerms is stored as the raw
// JSON string the API returns (see $Can), so `includes` is a substring match
// on permission names; it also works if it is ever stored as an array.
const LANDING_PAGES = {
  '/dashboard': 'tool_page_menu',
  '/': 'home_page_menu',
  '/published-rota': 'rota_live_page_menu',
};

/**
 * First path in `order` whose permission is in `perms`, or null when the user
 * holds none of them. The default order matches what login always did:
 * rota editors go to the unpublished rota, everyone else to Home.
 */
export const getLandingPathForPerms = (
  perms,
  order = ['/dashboard', '/', '/published-rota'],
) => {
  const held = perms || '';
  return order.find((path) => held.includes(LANDING_PAGES[path])) || null;
};

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole != '' && userRole != null) {
    return '/';
  } else {
    return { name: 'auth-login' };
  }
};
